(function () {
  var instances = new WeakMap();
  var observer = null;
  var SWIPER_SELECTOR = "[data-swiper-pages-grid], [data-swiper-products]";

  function parseNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function destroySwiper(element) {
    var instance = instances.get(element);
    if (!instance) return;

    instance.destroy(true, true);
    instances.delete(element);
  }

  function getProductsNavigation(element) {
    if (!element.hasAttribute("data-swiper-products")) return undefined;

    var sectionId = element.dataset.swiperProducts;
    if (!sectionId) return undefined;

    var prevEl = document.querySelector('[data-swiper-products-prev="' + sectionId + '"]');
    var nextEl = document.querySelector('[data-swiper-products-next="' + sectionId + '"]');

    if (!prevEl || !nextEl) return undefined;

    return {
      prevEl: prevEl,
      nextEl: nextEl
    };
  }

  function initSwiper(element) {
    if (!window.Swiper || !element) return;
    if (instances.has(element)) return;

    var spaceBetween = parseNumber(element.dataset.swiperSpaceBetween, 8);
    var mobileSlides = parseNumber(element.dataset.swiperSlidesMobile, 1.3);
    var desktopSlides = parseNumber(element.dataset.swiperSlidesDesktop, 3);
    var scrollbarEl = element.querySelector(".swiper-scrollbar");
    var navigation = getProductsNavigation(element);
    var scrollbarConfig = scrollbarEl
      ? {
          el: scrollbarEl,
          draggable: true,
          enabled: true
        }
      : null;

    var config = {
      slidesPerView: mobileSlides,
      spaceBetween: spaceBetween,
      mousewheel: {
        enabled: true,
        forceToAxis: true,
        releaseOnEdges: true,
        thresholdDelta: 6
      },
      breakpoints: {
        1024: {
          slidesPerView: desktopSlides
        }
      }
    };

    if (scrollbarConfig) {
      config.scrollbar = scrollbarConfig;
      config.breakpoints[1024].scrollbar = Object.assign({}, scrollbarConfig, { enabled: false });
    }

    if (navigation) {
      config.navigation = navigation;
    }

    var swiper = new window.Swiper(element, config);

    instances.set(element, swiper);
  }

  function initAllSwipers(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var elements = root.querySelectorAll(SWIPER_SELECTOR);

    elements.forEach(function (element) {
      initSwiper(element);
    });
  }

  function destroyAllSwipers(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var elements = root.querySelectorAll(SWIPER_SELECTOR);

    elements.forEach(function (element) {
      destroySwiper(element);
    });
  }

  function reinitFromEvent(event) {
    if (!event || !event.target) {
      destroyAllSwipers(document);
      initAllSwipers(document);
      return;
    }

    destroyAllSwipers(event.target);
    initAllSwipers(event.target);
  }

  function destroyFromEvent(event) {
    if (!event || !event.target) return;
    destroyAllSwipers(event.target);
  }

  /**
   * MutationObserver: detects when new swiper containers
   * appear in the DOM (hot-reload, theme editor, dynamic content).
   */
  function startObserver() {
    if (observer) return;

    observer = new MutationObserver(function (mutations) {
      var needsInit = false;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        // Check added nodes for swiper containers
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType !== 1) continue;

          if (
            node.hasAttribute &&
            (node.hasAttribute("data-swiper-pages-grid") || node.hasAttribute("data-swiper-products"))
          ) {
            needsInit = true;
            break;
          }
          if (node.querySelector && node.querySelector(SWIPER_SELECTOR)) {
            needsInit = true;
            break;
          }
        }

        if (needsInit) break;
      }

      if (needsInit) {
        // Small delay to let the DOM settle after hot-reload
        setTimeout(function () {
          initAllSwipers(document);
        }, 50);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Init on first load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllSwipers(document);
      startObserver();
    });
  } else {
    initAllSwipers(document);
    startObserver();
  }

  // Shopify theme editor events
  document.addEventListener("shopify:section:load", reinitFromEvent);
  document.addEventListener("shopify:section:reorder", reinitFromEvent);
  document.addEventListener("shopify:block:select", reinitFromEvent);
  document.addEventListener("shopify:block:deselect", reinitFromEvent);
  document.addEventListener("shopify:section:unload", destroyFromEvent);

  window.SlicySwiper = {
    initAll: initAllSwipers,
    initOne: initSwiper,
    destroyOne: destroySwiper
  };
})();
